// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/RequesterImageField/RequesterImageFieldContextMenu/index.tsx

import { Box } from '@modusign/design-system';

import { ContextMenuRow, ContextMenuWrapper } from '@app/components/ContextMenu';
import DataLabelInput from '@app/components/DataLabelInput';

interface RequesterImageFieldContextMenuProps {
  dataLabel: string;
  dataLabelErrorMessage: string;
  onChange: (dataLabel: string) => void;
}

export default function RequesterImageFieldContextMenu({
  dataLabel,
  dataLabelErrorMessage,
  onChange,
}: RequesterImageFieldContextMenuProps) {
  return (
    <Box
      sx={{
        left: '50%',
        position: 'absolute',
        top: '-22px',
        transform: 'translate(-50%, -100%)',
      }}
    >
      <ContextMenuWrapper>
        <ContextMenuRow>
          <DataLabelInput
            errorMessage={dataLabelErrorMessage}
            value={dataLabel}
            onChange={(value) => onChange(value)}
          />
        </ContextMenuRow>
      </ContextMenuWrapper>
    </Box>
  );
}
